import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "../Component";
import { getPublicUrl } from "../../utils/Utils";

/** In-page TC section nav — mirrors the four Teleconsultation menu entries. */
const NAV = [
  { id: "list", label: "Consultations", path: "teleconsultations" },
  {
    id: "catalogue",
    label: "Catalogue go-live",
    path: "teleconsultations/practitioner-approvals",
  },
  { id: "pilotage", label: "Pilotage", path: "teleconsultations/operations" },
  { id: "support", label: "Partner support", path: "teleconsultations/support-requests" },
];

function sectionForPath(pathname) {
  if (pathname.includes("/teleconsultations/support-requests")) return "support";
  if (pathname.includes("/teleconsultations/operations")) return "pilotage";
  if (pathname.includes("/teleconsultations/stats")) return "pilotage";
  if (pathname.includes("/teleconsultations/practitioner-approvals")) return "catalogue";
  if (pathname.includes("/teleconsultations/pending-partners")) return "catalogue";
  if (pathname.includes("/teleconsultations")) return "list";
  return null;
}

const TeleconsultationAdminFlowNav = ({ className = "mb-3" }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const section = sectionForPath(pathname);

  return (
    <div className={className} role="navigation" aria-label="Teleconsultation admin sections">
      <div className="d-flex flex-wrap align-items-center flex-g-2">
        {NAV.map((item) => {
          const href = getPublicUrl(item.path);
          const isActive = section === item.id;
          return (
            <Button
              key={item.id}
              size="sm"
              type="button"
              color={isActive ? "primary" : "light"}
              outline={!isActive}
              onClick={() => history.push(href)}
            >
              {item.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default TeleconsultationAdminFlowNav;
